import React from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Card,
  Image,
  CardBody,
  Heading,
  Stack,
  CardFooter,
  Link,
  UnorderedList,
  ListItem

} from "@chakra-ui/react";

import ReactPlayer from "react-player/youtube";


interface PortfolioProps {
  title: string;
  desc: string;
  link: string | null;
  linkLabel: string | null;
  role: string | null;
  tags: string[];
  image: string[];
  bullets: [string, string][];
  activeIdx: number;
  setActiveIdx: React.Dispatch<React.SetStateAction<number>>;
}

export default function ArtItem(props: PortfolioProps) {
  function handleLinkClick(){
    if (props.link) return props.link
    return ""
  }
    return (
      <Card
        direction="column"
        alignItems={"flex-start"}
        justifyContent="flex-start"
        variant="none"
        width={"90%"}
        height="85%"
        borderLeftRadius="1rem"
        borderRightRadius={{ base: "1rem", lg: "0rem" }}
        my="1rem"
        backgroundColor="offwhiteOpacity"
        backdropFilter="auto"
        backdropBlur="5px"
        border="lightgrey solid 1px"
        borderRight={{ base: "lightgrey solid 1px", lg: "none" }}
        py={{ lg: "2rem", base: "1rem" }}
        px={{ lg: "3rem", base: "2rem" }}
        gap="1rem"
        overflowY="hidden"
      >
        <Flex
          width="100%"
          flexDir={{ base: "row", lg: "column" }}
          justifyContent={{ base: "flex-start", lg: "center" }}
          alignItems={{ base: "center", lg: "flex-start" }}
          gap=".5rem"
        >
          <Text variant={"tinyHeader"}>{props.title}</Text>
        </Flex>
        <Flex
          height="80%"
          width="100%"
          display={props.image.length == 2 ? "none" : "flex"}
        >
          <Image
            objectFit="contain"
            src={props.image ? props.image[0] : ""}
            borderRadius={"1rem"}
            key={Date.now()}
          />
        </Flex>
        <Flex
          height="80%"
          width="80%"
          display={props.image.length == 2 ? "flex" : "none"}
        >
          <iframe
            src={props.image[1]}
            allow="autoplay; fullscreen; clipboard-write; encrypted-media"
            title={props.title}
            width="100%"
            style={{ padding: "0", margin: "0", background: "transparent" }}
            key={Date.now()}
          ></iframe>
        </Flex>
        <Text variant={"type"}>{props.desc}</Text>
      </Card>
    );
}